import styled from 'styled-components'
import media from 'styles/media'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;

  .container {
    display: block;
    line-height: 1;
  }
`

const Details = styled.div`
  min-height: 64px;
  align-self: start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 4px;
  flex-grow: 1;
  padding-left: 16px;

  @media (${media.screenSmMiniMax}) {
    padding-left: 8px;
  }
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 4px;

  .container-button {
    align-self: end;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
`

export { Wrapper, Details, FlexContainer, Info }
